import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { IDefaultGeneralGD } from '../models/defaultGD';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class HistorialMantenimientoService {
  private apiUrl: string = '';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.sUrlGd + 'maintenance/history';
  }

  getHistorialMantenimientoUnidad(unit: string): Observable<any> {
    const valores = {
      params: new HttpParams().
        set('EcoNum', unit)
    };

    return this.http
      .get<any>(this.apiUrl + '/unit', valores)
      .pipe(retry(1), catchError(this.handleError));
  }

  AddKilometrajeMantenimiento(data: any): Observable<IDefaultGeneralGD> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/add', body, { 'headers': headers });
  }

  DelKilometrajeMantenimiento(data: any): Observable<IDefaultGeneralGD> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/del', body, { 'headers': headers });
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
